import { useControls } from 'leva'
import { elastic } from './create-elastic'
import { defaultElasticElasticity, defaultElasticGravity, defaultElasticHang, defaultElasticVelocity, defaultElasticDecayX, defaultElasticDecayY } from '../assets/constants'

export function ElasticWrapper() {
  const { myElastic } = useControls({ myElastic: elastic({ elasticity: defaultElasticElasticity, gravity: defaultElasticGravity, decayX: defaultElasticDecayX, decayY:defaultElasticDecayY, hang: defaultElasticHang, velocity: defaultElasticVelocity})})
  return (
    <pre>
    </pre>
  )
}